import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_cash_document_hdr_RowClass, bl_fi_cash_document_line_RowClass,  } from "../../../dbschema";

export class CashDocumentContainerModel extends BaseContainerModel {
    bl_fi_cash_document_hdr: bl_fi_cash_document_hdr_RowClass = new bl_fi_cash_document_hdr_RowClass();
    bl_fi_cash_document_lines: bl_fi_cash_document_line_RowClass[] = [];
}
